<template>
  <div @keyup.enter="changePassword">
    <UiCard class="settings_wrapper">
      <div slot="title">
        <div class="title">Смена пароля</div>
      </div>

      <div slot="content">
        <UiFakeInputs />

        <!-- Old passwrod input -->
        <div class="row two-columns">
          <form-group :validator="$v.form.oldPassword" :server-errors="serverError('oldPassword')">
            <template slot-scope="{ attributes }">
              <UiInputText
                id="current-password"
                ref="oldPassword"
                v-model="form.oldPassword"
                placeholder="Текущий пароль"
                type="password"
                autocapitalize="off"
                autocomplete="current-password"
                autocorrect="off"
                :class="attributes.class"
                password-reveal
                @input="delayTouch($v.form.oldPassword, 'oldPassword')"
              />
            </template>
          </form-group>
        </div>

        <div class="row two-columns between-xs">
          <!-- New password input -->
          <form-group :validator="$v.form.newPassword" :server-errors="serverError('newPassword')">
            <template slot-scope="{ attributes }">
              <UiInputText
                id="new-password"
                ref="newPassword"
                v-model="form.newPassword"
                autocomplete="new-password"
                placeholder="Новый пароль"
                type="password"
                autocapitalize="off"
                autocorrect="off"
                :class="attributes.class"
                password-reveal
                @input="delayTouch($v.form.newPassword, 'newPassword')"
              />
            </template>
          </form-group>

          <!-- Same password input -->
          <form-group
            :validator="$v.form.samePassword"
            :server-errors="serverError('samePassword')"
          >
            <template slot-scope="{ attributes }">
              <UiInputText
                ref="samePassword"
                v-model="form.samePassword"
                placeholder="Повторите новый пароль"
                type="password"
                autocapitalize="off"
                autocorrect="off"
                :class="attributes.class"
                password-reveal
                @input="delayTouch($v.form.samePassword, 'samePassword')"
              />
            </template>
          </form-group>
        </div>
      </div>

      <div slot="footer">
        <UiButton
          :disabled="tryChangePassword"
          :class="['button', 'is-blue', { 'is-loading': tryChangePassword }]"
          @click="changePassword"
        >
          Сохранить
        </UiButton>
      </div>
    </UiCard>
  </div>
</template>

<script>
import UiCard from '@/components/card/UiCard.vue'
import UiFakeInputs from '@/components/UiFakeInputs.vue'
import UiInputText from '@/components/UiInputText.vue'
import UiButton from '@/components/UiButton.vue'

import { AuthService } from '@/services/auth.service'

import { required, sameAs, minLength } from 'vuelidate/lib/validators'
import {
  requireBigAlpha,
  requireSmallAlpha,
  requireNum,
  onlyAlphaAndSpecSymbols,
} from '@/mixins/customValidators.js'
import validationHelpers from '@/mixins/validationHelpers.js'

export default {
  components: {
    UiCard,
    UiFakeInputs,
    UiInputText,
    UiButton,
  },
  mixins: [validationHelpers],
  data() {
    return {
      tryChangePassword: false,
      error: false,

      form: {
        oldPassword: '',
        newPassword: '',
        samePassword: '',
      },
    }
  },
  validations: {
    form: {
      oldPassword: {
        required,
      },
      newPassword: {
        required,
        minLength: minLength(8),
        requireBigAlpha,
        requireSmallAlpha,
        requireNum,
        onlyAlphaAndSpecSymbols,
      },
      samePassword: {
        required,
        sameAs: sameAs('newPassword'),
      },
    },
  },
  methods: {
    clearForm() {
      this.form.oldPassword = ''
      this.form.newPassword = ''
      this.form.samePassword = ''

      this.$v.$reset()
    },
    async changePassword() {
      this.$v.$touch()
      this.clearFormServerErrors()
      if (this.$v.form.$invalid) return

      this.tryChangePassword = true
      try {
        const { oldPassword, newPassword, samePassword } = this.form
        await AuthService.changePassword({
          old_password: oldPassword,
          password: newPassword,
          password_confirmation: samePassword,
        })

        this.clearForm()

        this.$store.commit('toast/NEW', { type: 'success', message: 'Операция выполнена.' })
      } catch (error) {
        this.$store.commit('toast/NEW', { type: 'error', message: error.message })
        this.error = error.message
      } finally {
        this.tryChangePassword = false
      }
    },
  },
}
</script>
